export default __webpack_public_path__ + "static/media/youtube-logo.af345064.svg";